enum ArticleTypology {
  BIKE = 'velo',
  FREEPARK = 'consignepark',
  PARK = 'consigne',
  ACCESSORY = 'accessoire',
}

export default ArticleTypology;
